(() => {
  const form = document.getElementById('zendesk-contact-form');
  if (!(form instanceof HTMLFormElement)) return;

  const errorsEl = document.querySelector('.contact-form__errors');
  const successEl = document.querySelector('.contact-form__success');
  const fileInput = form.querySelector('input[type="file"]');
  const uploadBtn = form.querySelector('[data-upload-btn]');
  const uploadLabel = form.querySelector('.form-upload__label');

  if (fileInput instanceof HTMLInputElement && uploadBtn instanceof HTMLElement) {
    uploadBtn.addEventListener('click', () => fileInput.click());

    fileInput.addEventListener('change', () => {
      const files = Array.from(fileInput.files || []);
      if (uploadLabel instanceof HTMLElement) {
        uploadLabel.textContent = files.length ? files.map((f) => f.name).join(', ') : '';
      }
    });
  }

  // Honeypot check
  const isSpam = () => {
    const website = form.querySelector('input[name="website"]');
    const gender = form.querySelector('input[name="gender"]');
    return (
      (website instanceof HTMLInputElement && website.value !== '') ||
      (gender instanceof HTMLInputElement && gender.value !== '')
    );
  };

  /** @param {string[]} messages */
  function showErrors(messages) {
    if (!(errorsEl instanceof HTMLElement)) return;
    errorsEl.innerHTML = `<h4>Whoops! Something went wrong.</h4><ul>${messages.map((m) => `<li>${m}</li>`).join('')}</ul>`;
    errorsEl.classList.add('is-visible');
    errorsEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function clearErrors() {
    if (errorsEl instanceof HTMLElement) {
      errorsEl.classList.remove('is-visible');
      errorsEl.innerHTML = '';
    }
  }

  const showSuccess = () => {
    form.style.display = 'none';
    if (successEl instanceof HTMLElement) {
      successEl.innerHTML = "<p>Thank you for your message. We'll be in touch soon.</p>";
      successEl.classList.add('is-visible');
      successEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  };

  function buildFormData() {
    const data = new FormData(/** @type {HTMLFormElement} */ (form));

    const firstName = String(data.get('custom_fields[first_name]') || '');
    const lastName = String(data.get('custom_fields[last_name]') || '');
    data.set('custom_fields[customer_name]', `${firstName} ${lastName}`.trim());

    data.delete('website');
    data.delete('gender');

    return data;
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    clearErrors();

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    if (isSpam()) {
      showSuccess();
      return;
    }

    const submitBtn = form.querySelector('.contact-form__submit');
    if (submitBtn instanceof HTMLButtonElement) submitBtn.disabled = true;

    try { 
      const formData = buildFormData();

      const response = await fetch('https://zendesk.xrockeruk.com/api/v1/contact', {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        showSuccess();
      } else if (response.status === 422) {
        const json = await response.json().catch(() => ({}));
        const messages = Object.values(json.errors || {}).flat();
        showErrors(messages.length ? messages : ['An unexpected error occurred. Please try again.']);
      } else {
        showErrors(['An unexpected error occurred. Please try again.']);
      }
    } catch {
      showErrors(['A network error occurred. Please check your connection and try again.']);
    } finally {
      const btn = form.querySelector('.contact-form__submit');
      if (btn instanceof HTMLButtonElement) btn.disabled = false;
    }
  });
})();
